<template>
  <div :class="$style.expertList">
    <div :class="$style.expert" :key="index" v-for="(item, index) in expertList">
      <img :class="$style.avatar" :src="item.avatar">
      <div :class="$style.info">
        <div :class="$style.name">{{ item.name }}</div>
        <div :class="$style.intro">{{ item.title }}</div>
      </div>

      <div class="custom-scrollbar" :class="$style.card" v-html="item.introHtml"></div>
    </div>
  </div>
</template>

<script>
import { expertList } from './data'

export default {
  data () {
    return {
      expertList
    }
  },
  created () {

  },
  destroyed () {
  },
  methods: {
    jump () {
      location.href = this.product.link
    }
  }
}
</script>

<style lang="scss" module>
.expertList {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.expert {
  position: relative;
  display: flex;
  margin-top: 40px;
  cursor: pointer;

  &:hover {
    .card {
      opacity: 1;
    }
  }
}

.avatar {
  width: 150px;
  height: 188px;
}

.info {
  margin-left: 20px;
  padding-top: 40px;
  width: 194px;
}

.name {
  font-size: 24px;
  font-weight: 500;
  color: #404040;
  line-height: 33px;
}

.intro {
  margin-top: 16px;
  font-size: 15px;
  color: #888;
  line-height: 21px;
}

.card {
  box-sizing: border-box;
  position: absolute;
  left: 0;
  top: 0;
  width: 366px;
  height: 188px;
  overflow-y: auto;
  line-height: 24px;
  padding: 20px;
  box-shadow: 0px 2px 20px 0px rgba(151,151,194,0.5);
  border-radius: 12px;
  font-size: 13px;
  color: #FFFFFF;
  background: linear-gradient(138deg, #2E7DFF 0%, #71A7FF 100%);
  opacity: 0;
  transition: 0.3s all linear;
}
</style>
